import { api, type KatalogResponse, type User } from './lib/api.js';
import { el } from './lib/dom.js';
import { renderListe } from './views/liste.js';
import { renderLogin } from './views/login.js';
import { renderWizard } from './views/wizard/index.js';

/** Hash-Router: '' → Liste · '#/login' · '#/p/{id}' → Wizard */

const root = document.getElementById('app')!;
let user: User | null = null;
let katalog: KatalogResponse | null = null;

async function route(): Promise<void> {
  const hash = location.hash;

  if (hash === '#/login') {
    user = null;
    katalog = null;
    renderLogin(root, () => {
      location.hash = '';
    });
    return;
  }

  try {
    if (!user) user = (await api.me()).user;
    if (!katalog) katalog = await api.kataloge();
  } catch {
    location.hash = '#/login';
    return;
  }

  const wizard = /^#\/p\/([0-9a-f-]{36})$/.exec(hash);
  if (wizard?.[1]) {
    try {
      await renderWizard(root, wizard[1], user, katalog);
    } catch {
      root.replaceChildren(el('main', {}, ''));
      const m = root.querySelector('main')!;
      m.append(
        el(
          'div',
          { class: 'list-empty', style: 'margin-top:40px' },
          'Protokoll konnte nicht geladen werden.',
        ),
      );
      const back = el(
        'button',
        { class: 'btn', type: 'button', style: 'margin:14px auto;display:block' },
        'Zur Übersicht',
      );
      back.addEventListener('click', () => (location.hash = ''));
      m.append(back);
    }
    return;
  }

  await renderListe(root, user);
}

window.addEventListener('hashchange', () => void route());
void route();
